import {
  APaidEventDayTheWalletLists,
  APaidEventInDetail,
  TheBodyOfAPaidEventDetail,
} from '../domains/the-paid-event-the-wallet-shows';
import { FilterPaidEventDto } from '@smatchy/sdk';
export interface PaidEventKpis {
  escrow: number;
  available: number;
  transferred: number;
}
export interface PaidEventResponse {
  data: APaidEventDayTheWalletLists[];
  total: number;
  page: number;
  limit: number;
}
export class SetLoadingKpisPaidEventsAction {
  static readonly type = '[Event] Set loading kpis paid events';
}

export class SetLoadingFilterPaidEventsAction {
  static readonly type = '[Event] Set loading filter paid events';
  constructor(public loading: boolean) {}
}

export class LoadKpisPaidEventAction {
  static readonly type = '[Event] Load kpis paid events';
  constructor(public kpis: PaidEventKpis) {}
}

export class FilterPaidEventAction {
  static readonly type = '[Event] Filter paid events';
  constructor(public filter: FilterPaidEventDto) {}
}
export class FilterPaidEventSuccessAction {
  static readonly type = '[Event] Filter paid events success';
  constructor(public response: PaidEventResponse) {}
}
export class FilterPaidEventDetailAction {
  static readonly type = '[Event] Filter paid events detail';
  constructor(public id: string) {}
}
export class FilterPaidEventDetailSuccessAction {
  static readonly type = '[Event] Filter paid events detail success';
  constructor(public response: { event: TheBodyOfAPaidEventDetail }) {}
}
export class FailAction {
  static readonly type = '[Event] Action fail';
  constructor(public error: unknown) {}
}

export class ResetFilterPaidEventsAction {
  static readonly type = '[FilterEvents] ResetFilterEventsAction';
}

export class AddSportSelectedToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] AddSportSelectedToFilterPaidEventsAction';

  constructor(public sportId: string, public resetOther: boolean) {}
}
export class AddDateFilterToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] AddDateFilterToFilterPaidEventsAction';

  constructor(public dateFilter: string, public fromDate?: string, public toDate?: string) {}
}

export class RemoveSportSelectedToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] RemoveSportSelectedToFilterPaidEventsAction';

  constructor(public sportId: string) {}
}
export class RemoveDateFilterToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] RemoveDateFilterToFilterPaidEventsAction';
}
export class AddStatusToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] AddStatusToFilterPaidEventsAction';

  constructor(public payoutStatus: string) {}
}

export class RemoveStatusToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] RemoveStatusToFilterPaidEventsAction';
  constructor(public payoutStatus: string) {}
}
export class AddPriceToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] AddPriceToFilterPaidEventsAction';

  constructor(public priceFrom: number, public priceTo: number) {}
}

export class RemovePriceToFilterPaidEventsAction {
  static readonly type = '[FilterEvents] RemovePriceToFilterPaidEventsAction';
}
